import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { userDataAtom } from "../atoms/auth.atom";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../requester";

export const useLinkedInLogin = () => {
  const setUserData = useSetRecoilState(userDataAtom);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const linkedInSignIn = async (code: string, state: string) => {
    try {
      const url = `${baseURL}/api/auth/linkedin/callback?code=${encodeURIComponent(
        code
      )}&state=${encodeURIComponent(state)}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.msg || "LinkedIn login failed");
      }

      const data = await response.json();
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleLinkedInCallback = async (code: string, state: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await linkedInSignIn(code, state);
      const userData = { ...response, msg: undefined };
      localStorage.setItem("userData", JSON.stringify(userData));
      setUserData(userData);
      navigate("/codeyai/projects", { replace: true });
    } catch (error: any) {
      console.error("LinkedIn login error:", error);
      setError(error.message || "Failed to login with LinkedIn");
    } finally {
      setLoading(false);
    }
  };

  return {
    handleLinkedInCallback,
    setLoading,
    setError,
    loading,
    error,
  };
};